import React, {useState, useEffect} from 'react';
import { Link as RouterLink, Navigate } from 'react-router-dom';
import {connect} from 'react-redux';
import * as actions from '../../../store/actions'
import validate from 'validate.js';
import queryString from 'query-string'

import {
  GridLegacy as Grid,
  Button,
  TextField,
  Link,
  Typography
} from '@mui/material';
import useClasses from '../../../helpers/useClasses';

const schema = {
  email: {
    presence: { allowEmpty: false, message: 'is required' },
    email: true,
    length: {
      maximum: 64
    }
  }
};

const styles = theme => ({
  form: {
    paddingLeft: 100,
    paddingRight: 100,
    paddingBottom: 125,
    flexBasis: 700,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  },
  title: {
    marginTop: theme.spacing(3)
  },
  socialButtons: {
    marginTop: theme.spacing(3)
  },
  socialIcon: {
    marginRight: theme.spacing(1)
  },
  sugestion: {
    marginTop: theme.spacing(2)
  },
  textField: {
    marginTop: theme.spacing(2)
  },
  signInButton: {
    margin: theme.spacing(2, 0)
  }
});

const ForgotPassword  = (props) => {
  const {
    onForgotPasswordSubmit,
    error,
    forgotPasswordSuccess
  } = props

  // const isSuccess = token ? true : false;
  const message = error;

  const classes = useClasses(styles);

  const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {}
  });

  useEffect(() => {
    const errors = validate(formState.values, schema);

    setFormState(formState => ({
      ...formState,
      isValid: errors ? false : true,
      errors: errors || {}
    }));
  }, [formState.values]);

  const hasError = field =>
    formState.touched[field] && formState.errors[field] ? true : false;

  const handleChange = event => {
    event.persist();

    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]:
          event.target.type === 'checkbox'
            ? event.target.checked
            : event.target.value
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true
      }
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    let email = event.target.email.value;
    
    const data = {
      email: email
    };

    if(formState.isValid)
      onForgotPasswordSubmit(data);
  }

  if (forgotPasswordSuccess) {
    return <Navigate to="/login" />
  }

  return (
    <form
      className={classes.form}
      onSubmit={handleSubmit}
    >
      <Typography
        className={classes.title}
        variant="h2"
      >
        Forgot Your Password?
      </Typography>
        <Grid
          container
        >
          <Grid item>
            <Typography variant="h5" color="secondary">{message}</Typography>
          </Grid>
        </Grid>
      <TextField
        className={classes.textField}
        error={hasError('email')}
        fullWidth
        helperText={
          hasError('email') ? formState.errors.email[0] : null
        }
        label="Email address"
        name="email"
        onChange={handleChange}
        required
        type="text"
        value={formState.values.email || ''}
        variant="outlined"
        sx={{
          marginTop: '15px'
        }}
      />
      <Button
        className={classes.signInButton}
        color="primary"
        disabled={!formState.isValid}
        fullWidth
        size="large"
        type="submit"
        variant="contained"
        sx={{
          marginTop: '15px'
        }}
      >
        Request Password Reset
      </Button>
      <Typography
        color="textSecondary"
        variant="body1"
        sx={{
          marginTop: '15px'
        }}
      >
        <Link
          component={RouterLink}
          to="/login"
          variant="h6"
        >
          Do you know your password and want to log in?
        </Link>
      </Typography>
    </form>
  )
}

const mapStateToProps = state => {
  return {
    error: state.auth.error,
    forgotPasswordSuccess: state.auth.forgotPasswordSuccess
  }
}

const mapDispatchToProps = dispatch => ({
  onForgotPasswordSubmit: (data) => dispatch(actions.forgotPassword(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
